import { useRef, useState } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const MobileScrolling = ({ ...props }) => {
    const { heading, heading_img, iphoneImg, text, subheading, button, fn } = props;

    const containerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [scrollTop, setScrollTop] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartY(e.clientY);
        setScrollTop(containerRef.current.scrollTop);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        const dy = e.clientY - startY;
        containerRef.current.scrollTop = scrollTop - dy;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    return (
        <div className="component-mobile">
            <HeadingOne heading={subheading} image={heading_img} />
            <Card>
                <CardBody>
                    <div className="relative flex items-center justify-center">
                        <div className="w-4/12">
                            <div dangerouslySetInnerHTML={{ __html: text }}></div>
                        </div>

                        <div className="relative h-[820px] w-[460px]">
                            <img src={iphoneImg} alt="iPhone" className="h-full w-full object-contain" />

                            <div
                                ref={containerRef}
                                className={`scroll-container absolute top-[55px] left-[56px] h-[640px] w-[350px] select-none ${
                                    isDragging ? 'cursor-grabbing' : 'cursor-grab'
                                }`}
                                onMouseDown={handleMouseDown}
                                onMouseMove={handleMouseMove}
                                onMouseUp={handleMouseUp}
                                onMouseLeave={handleMouseUp}
                            >
                                {props.articles &&
                                    props.articles.map((article) => (
                                        <div key={article.id} className="article-mobile border-b pt-4">
                                            <div className="content">
                                                <h3 className="title mb-2 block font-bold">{article.title}</h3>
                                                {article.image && (
                                                    <div className="image mb-2">
                                                        <img src={article.image} alt={article.title} />
                                                    </div>
                                                )}
                                                <div className="desc" dangerouslySetInnerHTML={{ __html: article.text }}></div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </CardBody>

                <CardFooter>{button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}</CardFooter>
            </Card>
        </div>
    );
};

export default MobileScrolling;
